import { t } from '../../modules/infra/i18n';

export const AUTH_SET_USER = 'AUTH_SET_USER';
export const AUTH_DISCARD_USER = 'AUTH_DISCARD_USER';
export const CHANGE_SHOP = 'CHANGE_SHOP';
export const SIGN_UP_ERROR = 'SIGN_UP_ERROR';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const USER_TYPES = {
  customer: 0,
  barber: 1,
  shop: 2,
  admin: 3,
  regularAdmin: 4,
  agent: 5,
  brand: 6,
};
export const USER_TYPES_KEYS = {
  [USER_TYPES.customer]: 'auth:user_types.customer',
  [USER_TYPES.barber]: 'auth:user_types.barber',
  [USER_TYPES.shop]: 'auth:user_types.shop',
  [USER_TYPES.admin]: 'auth:user_types.super_admin',
  [USER_TYPES.regularAdmin]: 'auth:user_types.admin',
  [USER_TYPES.agent]: 'auth:user_types.agent',
  [USER_TYPES.brand]: 'auth:user_types.brand',
};

export const getUserTypeLabel = (userType) => {
  return t(USER_TYPES_KEYS[userType] || 'auth:user_types.unknown');
};

export const IMPERSONATE_USER = 'IMPERSONATE_USER';
export const REVERSE_USER = 'REVERSE_USER';
export const AUTH_SET_BARBER_USER = 'AUTH_SET_BARBER_USER';
export const SET_BARBER_USER = 'SET_BARBER_USER';
export const AUTH_UNSET_FIRST_LOGIN = 'AUTH_UNSET_FIRST_LOGIN';
export const SET_FRONTEND_FLAGS = 'AUTH_SET_FRONTEND_FLAGS';
export const AUTH_SET_ADMIN_USER = 'AUTH_SET_ADMIN_USER';
export const SET_PERMISSION_PASSCODE = 'SET_PERMISSION_PASSCODE';
export const SET_BRAND = 'SET_BRAND';
export const RESET_SHOP = 'RESET_SHOP';
export const DISMISS_MAINTENANCE_MESSAGE = 'DISMISS_MAINTENANCE_MESSAGE';
export const PERMISSION_PASSCODE_LOADING = 'USER_SHOP_PERMISSION_PASSCODE_LOADING';
export const PERMISSION_PASSCODE_LOADED = 'USER_SHOP_PERMISSION_PASSCODE_LOADED';
